export function todayIso() {
  return new Date().toISOString().slice(0, 10);
}

export function formatCurrency(value) {
  const amount = Number(value || 0);
  return `PHP ${amount.toLocaleString('en-PH', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function formatDate(value) {
  if (!value) {
    return '-';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return String(value);
  }

  return date.toLocaleDateString('en-PH', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function normalizeSearch(value) {
  return String(value || '').toLowerCase().trim();
}

export function branchCode(value) {
  return String(value || 'GEN')
    .toUpperCase()
    .replace(/\s+/g, '')
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 4) || 'GEN';
}

export function generateTxnNo(requestType, branchName) {
  const prefix = requestType === 'Cash Advance' ? 'CA' : 'PC';
  const date = todayIso().replace(/-/g, '');
  const rand = Math.floor(1000 + Math.random() * 9000);

  return `${prefix}-${branchCode(branchName)}-${date}-${rand}`;
}

export function generateLiquidationNo(branchName, liquidations = []) {
  const code = branchCode(branchName);
  const year = new Date().getFullYear();
  const branchCount = liquidations.filter((row) => branchCode(row.branch) === code).length;
  const sequence = String(branchCount + 1).padStart(4, '0');

  return `LIQ-${code}-${year}-${sequence}`;
}

export function parseNumber(value, fallback = 0) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}
